import UserSelectProvider from 'components/CIMSSelect/common/UserSelect/UserSelectContext'
import { RolesTable } from './components/RolesTable'
import { RolesTableProvider } from './RolesTableContext'

const Roles: React.FC = () => (
  <RolesTableProvider>
    <UserSelectProvider>
      <RolesTable />
    </UserSelectProvider>
  </RolesTableProvider>
)

export default Roles
